<template>
    <div>
      <v-container>
        <a @click.prevent="getEmailCount">Email count</a>
                <span class="ml-2" v-if="show">{{count}}</span>
        <v-card-title class="main-sect-title">
          <h2 class="tabHeader"> {{$t('settings.analytics')}}</h2>
        </v-card-title>
        <v-tabs ref="analyticsTabs"
                v-model="active"
                color="cyan"
                dark
                slider-color="#5a65db"
                class="analytics-tab-menu"
        >
          <v-tab key="users" :ripple="false">
            {{$t('settings.users')}}
          </v-tab>
          <v-tab key="Products" :ripple="false">
            {{$t('settings.products')}}
          </v-tab>
          <v-tab key="companies" :ripple="false">
            {{$t('settings.companies')}}
          </v-tab>
          <v-tab key="needs" :ripple="false">
            {{$t('headers.needs')}}
          </v-tab>
          <v-tab-item>
            <all-users></all-users>
          </v-tab-item>
          <v-tab-item>
            <my-products></my-products>
          </v-tab-item>
          <v-tab-item>
            <all-companies></all-companies>
          </v-tab-item>
          <v-tab-item>
            <all-needs></all-needs>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </div>
</template>

<script>
import AllUsers from './AllUsers'
import MyProducts from '../MyProducts'
import AllCompanies from './AllCompanies'
import AllNeeds from './AllNeeds'
export default {
  name: 'Analytics',
  components: {
    MyProducts,
    AllUsers,
    AllCompanies,
    AllNeeds
  },
  data: () => ({
    active: null,
    count: '',
    show: false
  }),
  methods: {
    getEmailCount () {
      this.$store.dispatch('auth/getEmailCount').then((res) => {
        this.show = !this.show
        this.count = res.count
      }).catch(console.error)
    }
  },
  mounted () {
    this.$refs.analyticsTabs.$el.querySelector('.v-tabs__bar').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.analyticsTabs.$el.querySelector('.v-tabs__bar').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/sass/desktop/analyticsPage.scss";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/Analytics.vue